/**
 * EXIF Viewer Classic — image metadata viewer
 *
 * A single web-accessible-resource group exposes four scripts under scripts/ to every
 * origin, with no use_dynamic_url — so each sits at a fixed URL. There are no exposed
 * images, so detection is a fetch: scripts/exifservice.js is the most distinctively
 * named of the set and its presence is conclusive.
 *
 * Manifest verified against version 3.0.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nafpfdcmppffipmhcpkbplhkoiekndck';

export const exifViewerClassic: ExtensionDefinition = {
  id: ID,
  name: 'EXIF Viewer Classic',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 80_000,
  notes:
    'Four scripts exposed to every origin with no dynamic URL and no exposed images, ' +
    'so detection is a fetch of the vendor-distinctive exifservice.js.',
  signals: [
    {
      id: 'war-exif-service-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch scripts/exifservice.js — the EXIF-parsing module, exposed to every origin ' +
        'at a fixed URL and distinctively named.',
      weight: 1,
      run: () => probeFetch(ID, 'scripts/exifservice.js'),
    },
    {
      id: 'war-shared-js',
      kind: 'web-accessible-resource',
      description: 'Fetch scripts/shared.js — a second exposed script path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'scripts/shared.js'),
    },
    {
      id: 'war-index-js',
      kind: 'web-accessible-resource',
      description: 'Fetch scripts/index.js — a third exposed script path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'scripts/index.js'),
    },
  ],
};
